/* SLINKFLOW brand mark rendered from the public logo asset (image-only). */
export default function BrandMark({ size = 'md' }) {
  const sizes = {
    sm: { img: 'h-5 md:h-6 w-auto', gap: 'gap-0' },
    md: { img: 'h-6 md:h-7 lg:h-6 w-auto', gap: 'gap-0' },
    lg: { img: 'h-6 md:h-8 lg:h-9 w-auto', gap: 'gap-0' },
    xl: { img: 'h-7 md:h-12 lg:h-14 w-auto', gap: 'gap-0' },
  }[size];
  const logoSrc = `${process.env.PUBLIC_URL}/logo.png`;

  return (
    <span className={`inline-flex items-center ${sizes.gap}`}>
      <img
        src={logoSrc}
        alt="SLINKFLOW"
        className={`site-logo shrink-0 object-contain ${sizes.img}`}
      />
    </span>
  );
}
